import i18next from '../i18n';

function getLang() {
  return i18next.language || "th";
}

export function getUserFullName(user) {
  if (!user) return "-";
  const lang = getLang();
  if (lang === "th") {
    return `${user.firstname || ""} ${user.lastname || ""}`.trim();
  }
  return user.firstname_en && user.lastname_en
    ? `${user.firstname_en} ${user.lastname_en}`.trim()
    : "-";
}

export function getUserNickName(user) {
  if (!user) return "-";
  const lang = getLang();
  return lang === "th"
    ? user.nickname_TH || "-"
    : user.nickname_EN || "-";
}

export function getUserPosition(user) {
  if (!user) return "-";
  const lang = getLang();
  return lang === "th"
    ? user.positionsName || "-"
    : user.positionName_EN || user.positionsName || "-";
}

export function getUserCompany(user) {
  if (!user) return "-";
  const lang = getLang();
  return lang === "th"
    ? user.companyName || "-"
    : user.companyName_EN || user.companyName || "-";
}

export function getUserBusinessUnit(user) {
  if (!user) return "-";
  const lang = getLang();
  return lang === "th"
    ? user.businessUnitName || "-"
    : user.businessUnitName_EN || user.businessUnitName || "-";
}

export function getUserDivision(user) {
  if (!user) return "-";
  const lang = getLang();
  return lang === "th"
    ? user.divisionName || "-"
    : user.divisionName_EN || user.divisionName || "-";
}

export function getUserDepartment(user) {
  if (!user) return "-";
  const lang = getLang();
  return lang === "th"
    ? user.departmentName || "-"
    : user.departmentName_EN || user.departmentName || "-";
}

export function getUserSection(user) {
  if (!user) return "-";
  const lang = getLang();
  return lang === "th"
    ? user.sectionName || "-"
    : user.sectionName_EN || user.sectionName || "-";
}

export function getUserLastName(user) {
  if (!user) return "-";
  const lang = getLang();
  return lang === "th"
    ? user.lastname || "-"
    : user.lastname_en || user.lastname || "-";
}

export function getUserFirstName(user) {
  if (!user) return "-";
  const lang = getLang();
  return lang === "th"
    ? user.firstname || "-"
    : user.firstname_en || user.firstname || "-";
}

export function getName(data) {
  if (i18next.language === "th") {
    return data.name;
  }
  return data.name_EN || data.name;
}
